import React from 'react'
import { observer } from 'mobx-react'
import Skeleton from 'react-loading-skeleton'

import { REACT_LOADING_DURATION } from '../../Loader/constants'

import { AppsListLoadingWrapper, AppLoadingWrapper } from './styledComponents'

class SlimbarSkeletonLoader extends React.Component {
   numberOfApps = 6
   render() {
      return (
         <AppsListLoadingWrapper>
            {Array.from(Array(this.numberOfApps).keys()).map(index => (
               <AppLoadingWrapper key={index}>
                  <Skeleton
                     duration={REACT_LOADING_DURATION}
                     width={40}
                     height={40}
                     style={{ borderRadius: 8 }}
                  />
               </AppLoadingWrapper>
            ))}
         </AppsListLoadingWrapper>
      )
   }
}

export default observer(SlimbarSkeletonLoader)
